import { Color } from '@material-ui/lab/Alert';
import _ from 'lodash';
import React, { useState } from 'react';
import { v4 as uuid } from 'uuid';
export type SnackbarMessageType = Color;

export interface SnackbarMessageBase {
	key: string;
	type: SnackbarMessageType;
}

export interface SnackbarSuccessMessage extends SnackbarMessageBase {
	message: string;
}

export interface SnackbarErrorMessage extends SnackbarMessageBase {
	message: string;
	correlationId?: string;
}

export type SnackbarMessage = SnackbarSuccessMessage | SnackbarErrorMessage;

export interface SnackbarHandlerContextType {
	messages: SnackbarMessage[];
	push: (message: string, type: SnackbarMessageType, correlationId?: string) => void;
	remove: (key: string) => void;
}

const useSnackbarHandlerContext = () => {
	const [messages, setMessages] = useState<SnackbarMessage[]>([]);

	const remove = (key: string) => {
		setMessages(_.reject(messages, (x) => x.key == key));
	};

	const push = (message: string, type: SnackbarMessageType, correlationId?: string) => {
		setMessages([...messages, { key: uuid(), message, correlationId, type }]);
	};

	return { remove, messages: _.take(messages, 3), push };
};

export const SnackbarHandlerContext = React.createContext<SnackbarHandlerContextType>({ messages: [], push: _.noop, remove: _.noop });

export interface SnackbarHandlerContextProps {
	children: JSX.Element | JSX.Element[];
}

export const SnackbarHandlerConsumer = SnackbarHandlerContext.Consumer;

export const SnackbarHandlerProvider = ({ children }: SnackbarHandlerContextProps) => {
	const ctx = useSnackbarHandlerContext();

	return <SnackbarHandlerContext.Provider value={ctx}>{children}</SnackbarHandlerContext.Provider>;
};
